(function(){

var repo = createRepo();

//.............................................................................

				//module: ./common/collapsableList
(function(define){
define([], function () {

    return {
        init: collapsableList
    };

    function collapsableList(domElement) {
        require.runnerBox.runElement(domElement);

        const listElements = domElement.getElementsByClassName("list-elements")[0]
            .getElementsByClassName("items-wrapper")[0]
            .getElementsByClassName("layout-wrapper");

        for (let i = 0; i<listElements.length; i++){
            listElements[i].id = `collapse-list-element-${i+1}`;
            listElements[i].classList.add('ring-collapse');

            const linkWrapper = listElements[i].getElementsByClassName("layout-item")[0]
                .getElementsByClassName("list-wrapper")[0];

            if (linkWrapper){
                const linkInside = document.createElement("a");
                const textInside = linkWrapper.getElementsByClassName('text')[0];
                const titleInside = linkWrapper.getElementsByClassName('title')[0];
                const descriptionInside = linkWrapper.getElementsByClassName('description')[0];

                linkInside.setAttribute("href", linkWrapper.getAttribute("href"));
                linkInside.setAttribute("title", "Read more");
                linkInside.setAttribute("class", "read-more-button");
                linkInside.appendChild(document.createTextNode("Read more"));

                listElements[i].getElementsByClassName("layout-item")[0].appendChild(textInside);
                listElements[i].getElementsByClassName("layout-item")[0].appendChild(titleInside);
                listElements[i].getElementsByClassName("layout-item")[0].appendChild(descriptionInside);
                listElements[i].getElementsByClassName("layout-item")[0]
                    .getElementsByClassName("description")[0].appendChild(linkInside);

                listElements[i].getElementsByClassName('list-wrapper')[0].remove();
            }

            const element = document.createElement("span");

            element.classList.add(`ring-collapse-button`);
            element.id = `collapse-list-button-${i+1}`;

            element.addEventListener('click', function() {
                const idToOpen = this.id.replace('collapse-list-button-','');
                const elementToOpen = document.getElementById(`collapse-list-element-${idToOpen}`)
                    .getElementsByClassName('layout-item')[0]
                    .getElementsByClassName('description')[0];

                if (!elementToOpen.classList.contains('opened')){
                    elementToOpen.classList.add('opened');
                    this.classList.add('opened');
                } else if (elementToOpen.classList.contains('opened')) {
                    elementToOpen.classList.remove('opened');
                    this.classList.remove('opened');
                }
            }, false);

            listElements[i]
                .getElementsByClassName('layout-item')[0]
                .appendChild(element);
        }
    }
});

}(repo.getDefine("./common", "collapsableList")));

//.............................................................................

				//module: ./common/detailNavigation
(function(define){
define([], () => {
    return {
        init,
    };

    function init(domElement) {
        require.runnerBox.runElement(domElement);

        const gridContainer = document.querySelector('#article .detailNavigationFixedTo .ring-grid-box-container');
        const isBeginButton = domElement.getAttribute('data-nav-begin-button');
        const isFixed = domElement.classList.contains('fixed-detail-navigation');

        if (isBeginButton === 'true') {
            document.getElementsByTagName('body')[0].setAttribute('id', 'nav-ring-begin');
        }

        scrollNavigation();

        document.addEventListener('scroll', scrollNavigation, { capture: true, passive: true, });

        window.addEventListener('resize', () => {
            setFixedNavigation(gridContainer, isFixed);
        }, { capture: true, passive: true, });

        function scrollNavigation() {
            const articleHeadings = document.querySelectorAll('[id*="nav-ring-"]');
            const navigationLinks = document.querySelectorAll('a[href*="#nav-ring-"]');
            let currentHeading = [];

            articleHeadings.forEach(el => {
                if (el.getBoundingClientRect().top <= 20) {
                    currentHeading.push(el.id);
                }
            });

            navigationLinks.forEach(navItem => {
                if (`${currentHeading[currentHeading.length - 1]}` === 'undefined') {
                    navigationLinks.forEach(link => {
                        link.parentElement.classList.remove('active');
                    });
                }

                if (navItem.hash === `#${currentHeading[currentHeading.length - 1]}`) {
                    navigationLinks.forEach(link => {
                        link.parentElement.classList.remove('active');
                    });
                    navItem.parentElement.classList.add('active');
                }
            });

            setFixedNavigation(gridContainer, isFixed);
        }

        // eslint-disable-next-line no-shadow
        function setFixedNavigation(element, isFixed) {
            let navWidth = domElement.parentElement.clientWidth;
            let isMobile = window.matchMedia('(max-width: 768px)').matches;

            navWidth -= parseInt(window.getComputedStyle(domElement.parentElement, null).getPropertyValue('padding-left'));
            navWidth -= parseInt(window.getComputedStyle(domElement.parentElement, null).getPropertyValue('padding-right'));

            if (isFixed && !isMobile) {
                // eslint-disable-next-line no-unused-expressions
                element.getBoundingClientRect().top <= 0
                    // eslint-disable-next-line max-len
                    ? (domElement.style.position = 'fixed', domElement.style.top = '5px', domElement.style.maxWidth = `${navWidth}px`, domElement.style.width = '100%')
                    : (domElement.style.position = 'static', domElement.style.maxWidth = '100%');
            }
        }
    }
});

}(repo.getDefine("./common", "detailNavigation")));

//.............................................................................

				//module: ./common/genericListAjaxInfinitiveScroll
(function(define){
define([], () => {
    /**
     * Initializes action for onscroll async fetching elements on lists + SEO
     * @param {HTMLElement} domElement
     */
    /* eslint-disable no-use-before-define */
    function init(domElement) {
        require.runnerBox.runElement(domElement);
        const attributes = domElement.attributes || {};
        const isMainSeoList = !(attributes['data-mainSeoList'] && attributes['data-mainSeoList'].value === 'false');
        const widgetConfigPath = attributes['data-widgetConfigPath'] && attributes['data-widgetConfigPath'].value || '';
        const widgetType = attributes['data-widgetType'] && attributes['data-widgetType'].value || '';
        const paginationQueryParamPhrase = attributes['data-paginationQueryParamPhrase'] && attributes['data-paginationQueryParamPhrase'].value || 'page';
        const button = domElement.querySelector('#ajax-button');
        const isSearch = attributes['data-isSearch'] && attributes['data-isSearch'].value === 'true';
        const isDebugMode = attributes['data-isDebugMode'] && attributes['data-isDebugMode'].value === 'true';
        const searchValue = attributes['data-searchValue'] && attributes['data-searchValue'].value || '';
        const replaceHistory = attributes['data-replaceHistory'] && attributes['data-replaceHistory'].value === 'true';
        const mainSeoListElement = domElement.getElementsByClassName('ring-mainSeoList');
        const dataLimit = mainSeoListElement[0]
                          && mainSeoListElement[0].dataset
                          && mainSeoListElement[0].dataset.numfound ? mainSeoListElement[0].dataset.numfound : 1000;
        const ajaxLimit = attributes['data-ajaxLimit'] && parseInt(attributes['data-ajaxLimit'].value) || 10;
        const maxPageNo = dataLimit > 1000 ? 1000 / ajaxLimit : Math.ceil(dataLimit / ajaxLimit);
        const numFoundElement = domElement.querySelector('[data-numFound]');
        const totalItemsCount = (numFoundElement === null ? 0 : parseInt(numFoundElement.dataset.numfound, 10));

        const regexPageParam = new RegExp(`(&|\\?)${paginationQueryParamPhrase}=`, 'g');
        const regexPageValue = new RegExp(`(${paginationQueryParamPhrase}=).*?(&|$)`, 'g');
        const regexLastParamChar = new RegExp(`(&|\\?)\\s*$`, 'g');
        const url = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
        // eslint-disable-next-line max-len
        const pageFullURL = attributes['data-canonicalUrl'] && attributes['data-canonicalUrl'].value || (window.location.href || '').replace(/(amp;&)|(&amp;)/g, '&').replace(/&+/g, '&').replace('?&', '?');
        const baseURL = pageFullURL.match(regexPageParam) ? pageFullURL.replace(regexPageValue, '').replace(regexLastParamChar, '') : pageFullURL;
        const paramPrefix = baseURL.indexOf('?') >= 0 ? '&' : '?';
        const startPage = pageFullURL.match(regexPageParam) ? parseInt(new URLSearchParams(window.location.search).get(paginationQueryParamPhrase)) : 1;
        const urlParams = new URLSearchParams(window.location.search);
        const pageNumberParam = urlParams.get('page');
        const pageClassRegexp = new RegExp(`(?:ajax-page-).*[0-9]`, 'gi');
        const pageNumberRegex = new RegExp(`[0-9]*[0-9]`, 'gi');
        const firstListElement = document.querySelectorAll('.generic-list-item')[0] || null;

        let page = startPage || 1;
        let sending = false;
        let tempItemsLength = 0;

        if (firstListElement !== null && !firstListElement.classList.contains('ajax-page-1')) {
            // eslint-disable-next-line no-unused-expressions
            pageNumberParam === null ? firstListElement.classList.add('ajax-page-0') : firstListElement.classList.add(`ajax-page-${pageNumberParam - 1}`);
        }

        // eslint-disable-next-line no-inner-declarations
        const setUpMetaElements = pageNumber => {
            const pageType = attributes['data-pageType'] && attributes['data-pageType'].value ? attributes['data-pageType'].value : '';
            const seoTitleDesc = attributes['data-seoTitleDesc'] && attributes['data-seoTitleDesc'].value ? attributes['data-seoTitleDesc'].value : '';
            let seoTitleDescObj = {};

            try {
                seoTitleDescObj = JSON.parse(seoTitleDesc);
            } catch (e) {
                if (isDebugMode) {
                    console.error('ERROR: genericListAjaxInfinitiveScroll() > setUpMetaElements() > title JSON.parse():', e);
                }
            }

            setUpURLs();
            setUpTitleDescription(seoTitleDescObj);
            setUpMetaTags();

            return true;

            function setUpURLs() {
                let canonicalTag = document.head.querySelector('link[rel="canonical"]') || null;
                const modifyUrl = pageNumber > 1 ? `${baseURL}${paramPrefix}${paginationQueryParamPhrase}=${pageNumber}` : `${baseURL}`;

                if (replaceHistory && window.history && window.history.replaceState) {
                    window.history.replaceState('', '', modifyUrl);
                } else if (window.history && window.history.pushState) {
                    window.history.pushState('', '', modifyUrl);
                }

                if (canonicalTag) {
                    canonicalTag.setAttribute('href', modifyUrl);
                }
            }

            function setUpTitleDescription(seoTitlesDescriptions) {
                let pageDescription = document.head.querySelector('meta[name="description"]') || null;

                if (document.title && pageDescription && pageDescription.content) {
                    switch (pageType) {
                        case 'list':
                            if (pageNumber === 1) {
                                document.title = `${seoTitlesDescriptions.listPageTitle || ''}`;
                                pageDescription.content = `${seoTitlesDescriptions.listPageDescription || ''}`;
                            } else {
                                document.title = `${(seoTitlesDescriptions.listPageNumberTitle || '').replace(/\d+/, pageNumber)}`;
                                pageDescription.content = `${(seoTitlesDescriptions.listPageNumberDescription || '').replace(/\d+/, pageNumber)}`;
                            }

                            break;

                        case 'topic':
                            if (pageNumber === 1) {
                                document.title = `${seoTitlesDescriptions.topicPageTitle || ''}`;
                                pageDescription.content = `${seoTitlesDescriptions.topicPageDescription || ''}`;
                            } else {
                                document.title = `${(seoTitlesDescriptions.topicPageNumberTitle || '').replace(/\d+/, pageNumber)}`;
                                pageDescription.content = `${(seoTitlesDescriptions.topicPageNumberDescription || '').replace(/\d+/, pageNumber)}`;
                            }

                            break;

                        case 'search':
                            document.title = `${seoTitlesDescriptions.searchPageTitle || ''}`;
                            pageDescription.content = `${seoTitlesDescriptions.searchPageDescription || ''}`;

                            break;

                        default:
                            // eslint-disable-next-line max-len
                            document.title = `${(seoTitlesDescriptions.otherPageTitle || '').charAt(0).toUpperCase() + (seoTitlesDescriptions.otherPageTitle || '').slice(1)}`;
                            // eslint-disable-next-line max-len
                            pageDescription.content = `${(seoTitlesDescriptions.otherPageDescription || '').charAt(0).toUpperCase() + (seoTitlesDescriptions.otherPageDescription || '').slice(1)}`;

                            break;
                    }
                }
            }

            function setUpMetaTags() {
                let pageMetaTag = document.head.querySelector('meta[name="robots"]');
                let pageRelPrev = document.head.querySelector('link[rel="prev"]');
                let pageRelNext = document.head.querySelector('link[rel="next"]');

                if (!pageMetaTag) {
                    const metaTag = document.createElement('meta');
                    metaTag.name = 'robots';
                    metaTag.content = 'index, follow';
                    document.head.appendChild(metaTag);
                }

                if (pageNumber > 1) {
                    seoPrevNext(pageRelPrev, 'prev', pageNumber - 1);
                } else if (pageRelPrev) {
                    pageRelPrev.remove();
                }

                if (pageNumber > 0 && page < maxPageNo) {
                    seoPrevNext(pageRelNext, 'next', pageNumber + 1);
                } else if (pageRelNext) {
                    pageRelNext.remove();
                }
            }
        };

        // checks for the first load page number
        if (isMainSeoList) {
            const articlesList = document.querySelectorAll('.generic-list-item');
            const firstArticleClass = articlesList[0].classList[articlesList[0].classList.length - 1];
            const firstArticlePageNumber = firstArticleClass.match(pageNumberRegex);
            const pageToSet = Number(firstArticlePageNumber[0]) + 1;

            if (pageToSet > 1) {
                setUpMetaElements(pageToSet);
            }
        }

        let seoObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const currentEntryPageClass = entry.target.classList[entry.target.classList.length - 1];
                    const currentPageFromRegex = currentEntryPageClass.match(pageClassRegexp);
                    const currentPageNumberFromRegex = currentPageFromRegex[0].match(pageNumberRegex) || [1];
                    const currentPageNumber = Number(currentPageNumberFromRegex[0]) + 1;

                    // SEO PART
                    if (isMainSeoList) {
                        setUpMetaElements(currentPageNumber);
                    }
                }
            });
        }, { root: null, rootMargin: '0px', threshold: 0.1, });

        const done = res => {
            sending = false;

            try {
                const listPageLoadedEvent = new CustomEvent('listPageLoaded', { bubbles: true, });
                const items = domElement.querySelectorAll('.generic-list-item');
                const articleList = domElement.querySelector('.article-list-items');
                items[items.length - 1].classList.add(`ajax-page-${page}`);
                const div = document.createElement('div');
                div.innerHTML = res.trim();

                div.querySelectorAll('.generic-list-item').forEach(el => {
                    if (el.outerHTML) {
                        articleList.appendChild(el);
                    }

                    return true;
                });

                window.require(['local/lazyLoad'], lazyLoad => {
                    lazyLoad.run(domElement);
                });

                document.dispatchEvent(listPageLoadedEvent);

                // eslint-disable-next-line no-use-before-define
                seoPrevNext(button, 'next', page + 2);
            } catch (e) {
                console.log(e);
            }

            const currentItemsLength = domElement.querySelectorAll('.generic-list-item').length;

            page += 1;

            if (totalItemsCount === 0) {
                if (currentItemsLength > tempItemsLength) {
                    tempItemsLength = currentItemsLength;
                } else {
                    button.classList.add('d-none');
                }
            } else if (page >= maxPageNo) {
                button.classList.add('d-none');
            }

            for (let i = 0; i <= maxPageNo; i++) {
                const pages = document.querySelectorAll(`.generic-list-item.ajax-page-${i}`);

                if (pages) {
                    pages.forEach(el => seoObserver.observe(el));
                }
            }

            return true;
        };

        const makeAjaxQuery = () => {
            if (!sending) {
                const searchParams = isSearch ? `&isSearch=true&searchValue=${searchValue}` : '';

                const queryParams = `widgetConfigPath=${widgetConfigPath}&ajax=true&${paginationQueryParamPhrase}=${page}&widgetType=${widgetType}${searchParams}`;
                const xhr = new XMLHttpRequest();
                xhr.open('get', url.concat('?', queryParams));

                xhr.onload = () => {
                    done(xhr.response);
                };

                xhr.onerror = () => {
                    // eslint-disable-next-line no-console
                    console.log('Error during ajax fetch');
                };

                sending = true;
                xhr.send();
            }
        };

        if (button) {
            button.addEventListener('click', event => {
                event.preventDefault();
                makeAjaxQuery();
            });
        }

        // eslint-disable-next-line consistent-return
        function seoPrevNext(selector, type, pageToSet) {
            // eslint-disable-next-line no-negated-condition
            if (!selector) {
                let selectorLink = document.createElement('link');
                let pageUrl = window.location.href.split(paginationQueryParamPhrase)[0].replace(regexLastParamChar, '');

                selectorLink.rel = type;
                selectorLink.href = pageToSet === 1 ? pageUrl : `${pageUrl}${paramPrefix}${paginationQueryParamPhrase}=${pageToSet}`;

                document.head.appendChild(selectorLink);
            } else {
                let selectorHref = selector.getAttribute('href');
                const selectorRegex = new RegExp(`(${paginationQueryParamPhrase}=)+.*[0-9]`, 'g');

                if (selectorHref && selectorHref.match(selectorRegex) && selectorHref.match(selectorRegex)[0].split('=')[1] !== pageToSet) {
                    if (pageToSet === 1) {
                        selectorHref = selectorHref.replace(selectorRegex, ``).replace(regexLastParamChar, '');
                    } else {
                        selectorHref = selectorHref.replace(selectorRegex, `${paginationQueryParamPhrase}=${pageToSet}`);
                    }
                } else if (selectorHref && pageToSet > 1) {
                    selectorHref = `${selectorHref}${paramPrefix}${paginationQueryParamPhrase}=${pageToSet}`;
                }

                selector.setAttribute('href', selectorHref);

                return true;
            }
        }
    }

    return {
        init,
    };
});

}(repo.getDefine("./common", "genericListAjaxInfinitiveScroll")));

//.............................................................................

				//module: ./common/header
(function(define){
define([], function () {
    return {
        // eslint-disable-next-line no-use-before-define
        fixedHeader,
        moreButtonBehavior,
    };

    function fixedHeader(domElement) {
        require.runnerBox.runElement(domElement);

        const initialClassList = domElement.className;
        const headerFixedClass = 'header-fixed';
        const headerPercentClass = 'fixed-percent';

        function throttle(fn, wait) {
            let time = Date.now();

            return () => {
                if ((time + wait - Date.now()) < 0) {
                    fn();
                    time = Date.now();
                }
            };
        }

        domElement.classList.add(`${headerPercentClass}-0`);

        window.addEventListener('scroll', throttle(() => {
            let percent = Number.parseInt(window.scrollY / domElement.clientHeight * 100);

            percent = percent > 100 ? 100 : percent;

            if (!domElement.classList.contains(`${headerPercentClass}-100`) || percent < 100) {
                window.requestAnimationFrame(() => {
                    domElement.className = initialClassList;
                    const arrayOfClasses = [`${headerPercentClass}-${percent}`];

                    if (percent > 0) {
                        arrayOfClasses.push(headerFixedClass);
                    }

                    domElement.classList.add(...arrayOfClasses);
                });
            }
        }, 16.6666), false);
    }

    function moreButtonBehavior(domElement) {
        try {
            const moreButtonLabel = domElement.dataset.moreButtonLabel || '';
            const headerBackground = domElement.dataset.headerBackground || 'initial';
            const menuElementsColor = domElement.dataset.menuElementsColor || 'initial';

            domElement.insertAdjacentHTML('beforeend',`<li class="more hidden"><a href="#" style="color: ${menuElementsColor}">${moreButtonLabel}</a><ul style="background-color: ${headerBackground}"></ul></li>`);

            let moreEl = domElement.querySelector('.more');
            let moreElUl = moreEl.querySelector('ul');
            _doCalculate();
            function _doCalculate(){
                let space = domElement.getBoundingClientRect().width - moreEl.getBoundingClientRect().width;
                domElement.querySelectorAll('.menu-item').forEach((item) => {
                    space -= item.getBoundingClientRect().width;
                    if (space < 0) {
                        moreEl.classList.remove('hidden');
                        space -= moreEl.getBoundingClientRect().width;
                        moreElUl.appendChild(item);
                    }
                });
            }
        }
        catch (e) {
            console.error(e);
        }

    }
});

}(repo.getDefine("./common", "header")));

//.............................................................................

				//module: ./common/lazyEmbeds
(function(define){
define([], () => {
    const config = {
        rootMargin: '0px 0px 300px 0px',
        threshold: [0, 0.15, 0.85, 1],
    };

    const init = domElement => {
        loadEmbeds(domElement);
    };

    const loadEmbeds = domElement => {
        let embed = '';

        try {
            embed = JSON.parse(domElement.getAttribute('data-embed'));
        } catch (e) {
            // TODO: show errors only on enabled "debug mode"
            console.error('ERROR: loadEmbeds() > JSON.parse(): ', e);
        }

        if (embed !== '') {
            const io = new IntersectionObserver(((entries, observer) => {
                entries.forEach(entry => {
                    const isIntersecting = entry.isIntersecting;

                    if (isIntersecting) {
                        const container = document.createElement('div');
                        domElement.appendChild(container);

                        container.innerHTML = embed;
                        const targetEmbed = domElement.querySelector('[data-run-module]');
                        require.runnerBox.runElement(targetEmbed);

                        _MObserve(targetEmbed, domElement);
                        _Unobserve(observer, entry);
                    }
                });
            }), config);
            io.observe(domElement);
        }
    };

    const _Unobserve = (observer, entry) => {
        observer.unobserve(entry.target);
        observer.disconnect();
    };

    function _MObserve(target, domElement) {
        const configMO = { attributes: true, childList: true, subtree: true, };

        const callback = function (mutationsList, observer) {
            for (const mutation of mutationsList) {
                if (mutation.addedNodes.length > 0) {
                    const iframeTarget = mutation.addedNodes[0];

                    iframeTarget.addEventListener('load', () => {
                        domElement.querySelector('.ringLoader').classList += ' hide';
                        observer.disconnect();
                    });
                }
            }
        };

        const observer = new MutationObserver(callback);
        observer.observe(target, configMO);
    }

    return {
        init,
    };
});

}(repo.getDefine("./common", "lazyEmbeds")));

//.............................................................................

				//module: ./common/simpleMenu
(function(define){
define([], () => {
    const init = (domElement) => {
        require.runnerBox.runElement(domElement);

        const handleMenuReveal = () => {
            const menuElements = [
                ...domElement.querySelectorAll(
                    '.ring-simple-menu--listWrapper'
                ),
            ];

            menuElements.map((el) => {
                if (el.children[0]) {
                    el.children[0].addEventListener('click', () => {
                        const isMobile = window.matchMedia('(max-width: 767px)')
                            .matches;
                        const isExpandable = el.children[1];
                        const linksWrapper = el.querySelector(
                            '.ring-simple-menu--list'
                        );
                        const arrow = el.querySelector(
                            '.ring-simple-menu--arrow'
                        );

                        if (isMobile && isExpandable) {
                            if (
                                linksWrapper.classList.contains(
                                    'ring-simple-menu--activeMobile'
                                )
                            ) {
                                linksWrapper.classList.remove(
                                    'ring-simple-menu--activeMobile'
                                );
                                arrow.classList.remove(
                                    'ring-simple-menu--arrow--active'
                                );
                            } else {
                                linksWrapper.classList.add(
                                    'ring-simple-menu--activeMobile'
                                );
                                arrow.classList.add(
                                    'ring-simple-menu--arrow--active'
                                );
                            }
                        }
                    });
                }
            });
        };

        handleMenuReveal();
    };

    return {
        init,
    };
});

}(repo.getDefine("./common", "simpleMenu")));

//.............................................................................

				//module: ./common/utils
(function(define){
define([], () => {
    return {
        setCookie,
        getCookie,
        removeCookie,
        makeXHRAjaxRequest,
        getOCDNUrl,
        makeUrl,
        popup,
    };

    // Cookie management
    function setCookie(cookieName, value, exdays, path) {
        let exdate = new Date(); let
            expires;
        let cPath = path ? `;path=${path}` : '';

        if (exdays === 0) {
            expires = 0;
        } else {
            exdate.setDate(exdate.getDate() + exdays);
            expires = exdate.toUTCString();
        }

        document.cookie = cookieName + "=" + escape(value) + cPath + ((exdays === null) ? "" : "; expires="+expires);
    }

    function getCookie(cookieName) {
        let i; let x; let y; let
            ARRcookies = document.cookie.split(';');

        if (ARRcookies && ARRcookies.length) {
            for (i = 0; i < ARRcookies.length; i++) {
                x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='));
                y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1);
                x = x.replace(/^\s+|\s+$/g, '');

                if (x === cookieName) {
                    return unescape(y);
                }
            }
        }

        return null;
    }

    function removeCookie(cookieName) {
        document.cookie = `${cookieName}=; Max-Age=-99999999;`;
    }

    // Ajax call
    function makeXHRAjaxRequest(method, url, queryParams = '', done) {
        const xhr = new XMLHttpRequest();
        xhr.open(method, url.concat('?', queryParams));

        xhr.onload = () => {
            done(null, xhr.response);
        };

        xhr.onerror = () => {
            done(xhr.response);
        };

        xhr.send();
    }

    // OCDN management
    function getOCDNUrl() {
        const styleSheets = document.querySelectorAll('[rel="stylesheet"]');

        for (let property in styleSheets) {
            if (styleSheets.hasOwnProperty(property)) {
                console.log(styleSheets.hasOwnProperty(property).href);
            }
        }
    }

    function makeUrl(baseUrl, params) {
        let out = [];

        for (let prop in params) {
            out.push(`${encodeURIComponent(prop)}=${encodeURIComponent(params[prop])}`);
        }

        if (out.length > 0) {
            if (baseUrl.indexOf('?') >= 0) {
                return `${baseUrl}&${out.join('&')}`;
            }

            return `${baseUrl}?${out.join('&')}`;
        }

        return baseUrl;
    }

    function popup(url, name, width, height) {
        let options = [
            ['width', width],
            ['height', height],
            ['scrollbars', '1'],
            ['scrollbars', 'yes'],
            ['toolbar', '0'],
            ['status', '0']
        ];

        let dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screen.left;
        let dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screen.top;

        // pobranie wymiarów zewnętrznych okna przeglądarki

        let outerWidth = window.outerWidth
            ? window.outerWidth
            : document.documentElement && document.documentElement.clientWidth
                ? document.documentElement.clientWidth
                : null;

        let outerHeight = window.outerHeight
            ? window.outerHeight
            : document.documentElement && document.documentElement.clientHeight
                ? document.documentElement.clientHeight
                : null;

        if (outerWidth !== null) {
            options.push(['left', Math.floor((outerWidth - width) / 2) + dualScreenLeft]);
        }

        if (outerHeight !== null) {
            options.push(['top', Math.floor((outerHeight - height) / 2) + dualScreenTop]);
        }

        window.open(url, name, optionsToString(options));

        function optionsToString(options) {
            let out = [];

            for (let i = 0; i < options.length; i++) {
                out.push(options[i].join('='));
            }

            return out.join(', ');
        }
    }
});

}(repo.getDefine("./common", "utils")));

//.............................................................................

				//module: ./common/themeSwitcher
(function(define){
define(['./utils'], Utils => {
    const THEME_LIGHT = 'light';
    const THEME_DARK = 'dark';
    const COOKIE_EXP_TIME_DAYS = 30;

    return {
        themeSwitcher,
    };

    function themeSwitcher(domElement) {
        require.runnerBox.runElement(domElement);
        const cssVariables = document.getElementById('variables-styles');
        const themeSwitcherElements = document.getElementsByClassName('theme-switcher-element');

        domElement.addEventListener('click', e => {
            e.preventDefault();

            // reflect user changes right away
            domElement.classList.toggle(getActualTheme(cssVariables));
            domElement.classList.toggle(getNextTheme(cssVariables));

            preload({
                as: 'style',
                url: getNextThemeUrl(cssVariables),
                onLoad: () => {
                    // change layout when theme styles were downloaded and ready to swap
                    cssVariables.setAttribute('href', getNextThemeUrl(cssVariables));
                    cssVariables.setAttribute('data-theme', getNextTheme(cssVariables));
                    Utils.setCookie('themeVariant', getActualTheme(cssVariables), COOKIE_EXP_TIME_DAYS, '/');
                    changeThemeVariantOn(themeSwitcherElements, cssVariables);
                },
            });
        });
    }

    function getActualTheme(element) {
        return element.dataset.theme || THEME_LIGHT;
    }

    function getNextTheme(element) {
        return getActualTheme(element) === THEME_LIGHT ? THEME_DARK : THEME_LIGHT;
    }

    function getNextThemeUrl(element) {
        return element.getAttribute('href').replace(getActualTheme(element), getNextTheme(element));
    }

    /**
     * Preload resource before change source attribute.
     * This will prevent bug when user has slow connection when changed element doesn't download enough fast to show (element will disappear)
     * @param {string} url
     * @param {string} as
     * @param {Function} onLoad
     * @param {Function} onError
     */
    // eslint-disable-next-line no-empty-function
    function preload({ url, as = 'style', onLoad, onError = () => { }, }) {
        const linkTag = document.createElement('link');
        linkTag.setAttribute('rel', 'preload');
        linkTag.setAttribute('as', as);
        linkTag.setAttribute('href', url);
        linkTag.addEventListener('load', () => {
            onLoad(linkTag);
            linkTag.remove();
        });
        linkTag.addEventListener('error', () => {
            onError(linkTag);
            linkTag.remove();
        });
        document.getElementsByTagName('head')[0].appendChild(linkTag);
    }

    function changeThemeVariantOn(elements, cssVariablesElement) {
        const elementsArr = [...elements];

        elementsArr.forEach(element => {
            const newSrc = element.getAttribute(`data-src-${getActualTheme(cssVariablesElement)}`);

            if (newSrc) {
                if (element.tagName === 'SOURCE') {
                    preload({
                        as: 'image',
                        url: newSrc,
                        onLoad: () => {
                            element.setAttribute('srcset', newSrc);
                        },
                    });
                } else {
                    element.setAttribute('src', newSrc);
                }
            }
        });
    }
});

}(repo.getDefine("./common", "themeSwitcher")));

//.............................................................................

				//module: ./common
(function(define){
define([
    './common/collapsableList',
    './common/themeSwitcher',
    './common/detailNavigation',
    './common/simpleMenu',
    './common/genericListAjaxInfinitiveScroll',
    './common/header',
    './common/lazyEmbeds'
], (
    collapsableList,
    themeSwitcher,
    detailNavigation,
    simpleMenu,
    genericListAjaxInfinitiveScroll,
    header,
    lazyEmbeds
// eslint-disable-next-line max-params
) => ({
    collapsableList: collapsableList.init,
    themeSwitcher: themeSwitcher.themeSwitcher,
    detailNavigation: detailNavigation.init,
    simpleMenu: simpleMenu.init,
    genericListAjaxInfinitiveScroll: genericListAjaxInfinitiveScroll.init,
    fixedHeader: header.fixedHeader,
    lazyEmbeds: lazyEmbeds.init,
    headerMoreButtonBehavior: header.moreButtonBehavior,
}));

}(repo.getDefine(".", "common")));

//.............................................................................

repo.install("./common");

//.............................................................................

function createRepo() {

    var isInstall = false;
    //moduły zewnętrzne
    var modulesExt = createModulesExt();
    //moduły lokalne
    var modules = {};

    return {
        getDefine: getDefine,
        install: install
    };

    function getDefine(path, name) {

        return function(deps, def) {

            if (isInstall === false) {

                modules[path + '/' + name] = createEvalModule(path, deps, def);

            } else {

                throw Error('You cannot define module after configuration process');
            }
        };
    }

    function createEvalModule(path, deps, def) {

        var moduleObject = null;

        addToExt(deps);

        return {
            'get': get
        };

        function get(extModuleObj) {

            if (moduleObject === null) {
                moduleObject = createModuleObject(extModuleObj);
            }

            return moduleObject;
        }

        function createModuleObject(extModuleObj) {

            var depsResolve = [];

            for (var i = 0; i < deps.length; i++) {
                depsResolve.push(resolve(deps[i]));
            }

            return def.apply(null, depsResolve);

            function resolve(moduleName) {

                if (isModuleLocal(moduleName)) {

                    return getLocal(moduleName);

                } else {

                    return getExtends(moduleName);
                }
            }

            function getExtends(moduleName) {

                if (moduleName in extModuleObj) {
                    return extModuleObj[moduleName];
                } else {
                    throw Error('There is no definition for external module: ' + moduleName);
                }
            }

            function getLocal(moduleName) {

                var modulePath = path + '/' + moduleName;
                var out;

                var modulePathNormalize = normalizePath(modulePath);

                if (typeof(modulePathNormalize) === 'string' && modulePathNormalize !== '') {

                    out = getFromModules(modulePathNormalize);

                    if (out !== null) {
                        return out;
                    } else {
                        throw Error('There is no definition for module: ' + modulePathNormalize);
                    }

                } else {

                    throw Error('There is a problem with path normalization: ' + modulePath);
                }

                function getFromModules(moduleFullName) {

                    var value = modules[moduleFullName];

                    if (typeof(value) !== 'undefined') {
                        return value.get(extModuleObj);
                    } else {
                        return null;
                    }
                }
            }
        }
    }

    function normalizePath(path) {

        var chunks = path.split('/');

        var newChunks = [];

        for (var i = 0; i < chunks.length; i++) {

            var value = chunks[i];

            if (value === '.') {

                if (newChunks.length === 0) {

                    newChunks.push(value);

                } else {

                    //ignoruj znak
                }

            } else if (value === '..') {

                if (newChunks.length >= 2) {

                    newChunks.pop();

                } else {

                    return null;
                }

            } else {

                newChunks.push(value);
            }
        }

        return newChunks.join('/');
    }

    function addToExt(deps) {

        for (var i = 0; i < deps.length; i++) {
            add(deps[i]);
        }

        function add(moduleName) {

            if (isModuleLocal(moduleName)) {

            } else {

                modulesExt.addName(moduleName);
            }
        }
    }

    function isModuleLocal(moduleName) {

        if (typeof(moduleName) === 'string') {

            if (moduleName.length >= 2 && moduleName.substr(0, 2) === './') {
                return true;
            } else if (moduleName.length >= 3 && moduleName.substr(0, 3) === '../') {
                return true;
            } else {
                return false;
            }

        } else {

            throw Error('Module name should be string');
        }
    }

    function getModule(name, extModuleObj) {

        if (typeof(modules[name]) !== 'undefined') {
            return modules[name].get(extModuleObj);
        } else {
            throw Error('Module not defined: ' + name);
        }
    }

    //instalowanie zewnętrznej końcówki odnoszącej się do requirejs (która pobierze zewnętrzne moduły)
    function install(mainModule) {

        if (isInstall === false) {

            isInstall = true;

            define(modulesExt.getModulesName(), function() {

                //konwersja "arguments" na tablicę
                var copyParams = Array.prototype.slice.call(arguments, 0);

                //potrzebne do evaluowania ...
                var moduleObj = modulesExt.getExtendsModulesObject(copyParams);

                //ewaluowanie głównego modułu - z podmodułami jeśli trzeba
                return getModule(mainModule, moduleObj);
            });

        } else {

            throw Error('Unsupported state');
        }
    }

    function createModulesExt() {

        var isSet = false;

        var modulesName = [];
        var modulesExtValue = {};

        return {
            'addName': addName,
            'getExtendsModulesObject': getExtendsModulesObject,
            'getModulesName': getModulesName
        };

        function getExtendsModulesObject(modules) {

            if (modulesName.length === modules.length) {

                return getObj();

            } else {

                throw Error('Unsupported state');
            }

            function getObj() {

                var out = {};

                for (var i = 0; i < modulesName.length; i++) {
                    setOut(modulesName[i], modules[i]);
                }

                return out;

                function setOut(name, value) {
                    out[name] = value;
                }
            }
        }

        function getModulesName() {

            return modulesName;
        }

        function addName(name) {

            if (isSet === false) {

                if (isNoEmptyString(name)) {

                    if (typeof(modulesExtValue[name]) !== 'string') {

                        modulesExtValue[name] = name;
                        modulesName.push(name);
                    }

                } else {

                    throw Error('Unsupported parameter type');
                }

            } else {

                throw Error('Unsupported state');
            }
        }
    }

    function isNoEmptyString(value) {

        return (typeof(value) === 'string' && value !== '');
    }
}


//.............................................................................

}());